import React, { useEffect, useState, useContext } from 'react';
import './PageHeader.css';

import { MdKeyboardArrowRight, MdOutlineLogout } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import { IoMdNotificationsOutline } from "react-icons/io";
import { IoMenu } from "react-icons/io5";
import { MdLanguage } from "react-icons/md";
import { useTranslation } from 'react-i18next';
import defaultLogo from '../../Assets/logo/logo_white.png';

import GlobalContext from "../../context/GlobalContext";
import AuthContext from "../../context/Services/Auth";
import { get_branding } from "../../context/Services/Branding";

import { useLocation, useNavigate } from 'react-router-dom';
import { IoIosSettings } from "react-icons/io";


const PathTitles = {
	'': 'Dashboard',
	'dashboard': 'Dashboard',
	'staff': 'Staff',
	'settings': 'Settings',
	'add_stock': 'Add Stock',
	'stock': 'Stock',
	'add_staff': 'Add Staff',
	'settings': 'Settings',
	"suppliers": "Fournisseur",
	"costs": "Frais",
	"shipments": "Livraison",
}

const languages = [
	{ code: 'fr', label: 'Français' },
	{ code: 'ar', label: 'العربية' },
];

const PageHeader = ({ showSideBar, setShowSideBar }) => {
	const { userData, logoutUser } = useContext(AuthContext);

	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	const location = useLocation();
	const path = location.pathname.split('/')[1];

	const [spreadSearch, setSpreadSearch] = useState(false);
	const [showNotification, setShowNotification] = useState(false);
	const [showStores, setShowStores] = useState(false);
	const [showLangDropdown, setShowLangDropdown] = useState(false);
	const [logo, setLogo] = useState(defaultLogo);

	const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

	// Fetch dynamic logo
	useEffect(() => {
		const fetchLogo = async () => {
			try {
				const res = await get_branding('website_logo');
				if (res?.data) {
					setLogo(res.data);
				}
			} catch (e) {
				console.log('Using default logo');
			}
		};
		fetchLogo();
	}, []);

	useEffect(() => {
		if (showNotification) {
			setShowNotification(false)
		}

		if (showStores) {
			setShowStores(false)
		}

		if (showLangDropdown) {
			setShowLangDropdown(false)
		}
	}, [path])

	const handleLanguageChange = (langCode) => {
		i18n.changeLanguage(langCode);
		setShowLangDropdown(false);
	};

	return (
		<div className="header_conatiner flex items-center">
			<IoMenu className='pointer transition menu_icon' onClick={() => setShowSideBar(!showSideBar)} />
			<img src={logo} className="sidebar_logo" alt="logo" />

			<div className="header_tools flex items-center" style={{ gap: "10px" }}>

				{
					userData?.role === "admin" &&
					<div className="relative flex justify-center " style={{ margin: 0 }} onClick={() => navigate("/settings")}>
						<IoIosSettings className='search_icon pointer transition' />
					</div>
				}

				<div className="relative flex justify-center " style={{ margin: 0 }}>
					<IoMdNotificationsOutline className='search_icon pointer transition' onClick={() => setShowNotification(!showNotification)} />
					{
						showNotification &&
						<div className="notifcation_main shadow_spread">
							{t('aucune')}
						</div>
					}
				</div>

				{/* Language Dropdown */}
				<div className="relative" style={{ margin: 0 }}>
					<div
						onClick={() => setShowLangDropdown(!showLangDropdown)}
						className="search_icon pointer flex items-center gap"
						style={{ gap: "5px", padding: "8px 12px" }}
					>
						<MdLanguage style={{ fontSize: "1.1rem" }} />
						<span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{currentLang.code.toUpperCase()}</span>
					</div>
					{
						showLangDropdown &&
						<div className="lang_dropdown shadow_spread">
							{languages.map((lang) => (
								<div
									key={lang.code}
									className={`lang_option ${i18n.language === lang.code ? 'lang_active' : ''}`}
									onClick={() => handleLanguageChange(lang.code)}
								>
									{lang.label}
								</div>
							))}
						</div>
					}
				</div>

				<div
					onClick={logoutUser}
					className="relative flex justify-center search_icon pointer logout_header_btn"
					style={{ margin: 0 }}
					title={t("Logout")}
				>
					<MdOutlineLogout style={{ fontSize: "1.1rem" }} />
				</div>

			</div>
		</div>
	)
}

export default PageHeader